<template>
  <card>
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3 sm:gap-4">
        <div
          :class="[
            'text-2xl sm:text-3xl p-2 sm:p-3 rounded-xl',
            type === 'total'
              ? 'bg-[#FF5722] bg-opacity-10 text-[#FF5722]'
              : type === 'active'
              ? 'bg-green-100 text-green-600'
              : 'bg-red-100 text-red-600'
          ]"
        >
          <slot name="icon"></slot>
        </div>
        <div>
          <h3 class="text-base sm:text-lg font-semibold text-[#4A4453]">
            {{ title }}
          </h3>
          <p
            class="text-2xl sm:text-3xl font-bold mt-1 sm:mt-2"
            :class="[
              type === 'total'
                ? 'text-[#FF5722]'
                : type === 'active'
                ? 'text-green-600'
                : 'text-red-600'
            ]"
          >
            {{ value }}
          </p>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import card from "./Card.vue";

export default {
  name: "StatsCard",
  components: {
    card
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ["total", "active", "inactive"].includes(value);
      }
    }
  }
};
</script>
